import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext } from 'react';
import cx from 'classnames';
import Context from './Context';
import Portal from '../Portal';
import { useOnClickOutside } from '../../hooks';
import _styles from './Tooltip.module.scss';
const TooltipContent = ({ children, className, style, color = 'white' }) => {
    const { styles, attributes, setRefContent, refContent, setIsOpen, isOpen, targetClassName, setRefArrow, hasArrow } = useContext(Context);
    useOnClickOutside({ current: refContent }, () => {
        setIsOpen(false);
    }, { ignoreClassNames: [targetClassName] });
    const onClose = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);
    return isOpen ? (_jsx(Portal, { children: _jsxs("div", { className: cx(_styles.popover, _styles[color]), style: styles.popper, ref: setRefContent, ...attributes.popper, children: [_jsx("div", { className: cx(_styles.popoverContent, className), style: style, children: typeof children === 'function' ? children({ onClose }) : children }), hasArrow && _jsx("div", { ref: setRefArrow, className: cx(_styles.arrow, _styles[color]), style: styles.arrow })] }) })) : null;
};
export default Object.assign(memo(TooltipContent), { displayName: 'TooltipContent' });
